<template>
  <b-col
    :cols="colSize * 6"
    :sm="colSize * 4"
    :md="colSize * 2"
    :lg="colSize * 2"
    :xl="colSize"
    :offset="offset"
    v-bind="$attrs"
  >
    <b-form-group :label="label" label-for="input" :label-cols="labelCols">
      <date-picker
        :first-day-of-week="1"
        format="DD.MM.YYYY"
        :data-vv-as="label"
        range
        v-bind:value="value"
        @change="$emit('onChange', $event)"
        @input="$emit('input', $event)"
        :lang="lang"
        width="100%"
      ></date-picker>
    </b-form-group>
  </b-col>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
  name: 'date-range',
  props: ['value', 'label', 'cols', 'labelCols', 'offset'],
  computed: {
    colSize: function() {
      return this.cols || 3;
    },
  },
  data() {
    return {
      lang: 'ru',
    };
  },
  created() {
      this.lang = (localStorage.lang || 'ru').toLowerCase();
      EventBus.$on('lang-changed', (lang) => {
        this.lang = lang;
      });
  }
};
</script>

